export enum Layout {
  DEFAULT,
  NO_FOOTER,
  NO_LAYOUT,
}
